<div class="card monitoramento-page">
    <p-toolbar styleClass="mb-4 monitoramento-toolbar">
        <div class="filters-primary">
            <div class="field field-periodo">
                <label for="range" class="filter-label-fixed">Período</label>
                <p-datepicker appendTo="body" dateFormat="dd/mm/yy"
                    [(ngModel)]="rangeDate" selectionMode="range" inputId="range" styleClass="w-full"
                    [disabled]="isTodosMonitoramentos()">
                </p-datepicker>
            </div>
            <div class="field field-estacao">
                <label for="estacao" class="filter-label-fixed">Filtro de estações</label>
                <p-multiSelect appendTo="body" inputId="estacao" [filter]="true" filterLocale="pt-BR" [options]="dropDownEstacao"
                    [(ngModel)]="estacao_ids" optionLabel="label" styleClass="w-full">
                </p-multiSelect>
            </div>
            <div class="field field-situacao">
                <label for="situacao" class="filter-label-fixed">Situação</label>
                <p-dropdown appendTo="body" inputId="situacao" [options]="dropDownSituacao"
                    [(ngModel)]="situacao" (onChange)="onSituacaoChange()" styleClass="w-full">
                </p-dropdown>
            </div>
            <div class="field field-grupo-email">
                <label for="grupo-email" class="filter-label-fixed">Grupo de e-mail</label>
                <p-dropdown appendTo="body" inputId="grupo-email" [filter]="true" [options]="dropDownGrupoEmail"
                    [(ngModel)]="grupo_email_id" styleClass="w-full">
                </p-dropdown>
            </div>
            <div class="field field-actions">
                <span class="filter-label-fixed filter-label-actions">&nbsp;</span>
                <div class="actions-group">
                    <button *ngIf="!load" pButton pRipple pTooltip="Filtrar" (click)="filtrar()" type="button"
                        [disabled]="!podeFiltrar()"
                        icon="pi pi-search" class="p-button-rounded p-button-success"></button>
                    <button pButton pRipple type="button" (click)="toggleFiltroAvancado()" pTooltip="Filtro avançado"
                        icon="pi pi-filter" class="p-button-rounded p-button-text p-button-plain"></button>
                    <button pButton pRipple type="button" (click)="enviarEmailEstacao()"
                        [disabled]="!podeEnviarEmailEstacao() || loadingEnviarEmail"
                        [loading]="loadingEnviarEmail"
                        pTooltip="Enviar e-mail de monitoramento para os grupos da estação selecionada"
                        icon="pi pi-send" class="p-button-rounded p-button-info"></button>
                    <p-progressSpinner *ngIf="load" [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner"
                        strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
                </div>
            </div>

            <div *ngIf="exibirFiltroAvancado" class="filters-advanced">
                <div class="field">
                    <label class="filter-label-fixed">Grupos</label>
                    <p-multiSelect [options]="dropDownGrupos" appendTo="body" [filter]="true" [(ngModel)]="grupo"
                        optionLabel="label" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field">
                    <label class="filter-label-fixed">Cliente</label>
                    <p-multiSelect [options]="dropDownClientes" appendTo="body" [filter]="true" [(ngModel)]="cliente"
                        optionLabel="label" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field">
                    <label class="filter-label-fixed">Sensores</label>
                    <p-multiSelect [options]="dropDownSensores" appendTo="body" [filter]="true" [(ngModel)]="sensor"
                        optionLabel="label" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field">
                    <label class="filter-label-fixed">PLU</label>
                    <input type="text" class="p-inputtext p-component w-full" [(ngModel)]="plu_filtro" pInputText>
                </div>
                <div class="field">
                    <label class="filter-label-fixed">FLU</label>
                    <input type="text" class="p-inputtext p-component w-full" [(ngModel)]="flu_filtro" pInputText>
                </div>
                <div class="field">
                    <label class="filter-label-fixed">Integrador</label>
                    <p-multiSelect [options]="dropDownIntegradores" appendTo="body" [filter]="true"
                        [(ngModel)]="integrador_filtro" optionLabel="descricao" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field">
                    <label class="filter-label-fixed">Coletor</label>
                    <p-multiSelect [options]="dropDownColetores" appendTo="body" [filter]="true"
                        [(ngModel)]="coletor_filtro" optionLabel="descricao" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field field-novo-grupo">
                    <label class="filter-label-fixed filter-label-actions">&nbsp;</label>
                    <button pButton pRipple type="button" label="Novo grupo de estação" (click)="addNovoGrupo()"
                        icon="pi pi-plus" class="p-button-success w-full"></button>
                </div>
            </div>
        </div>
    </p-toolbar>

    <div class="monitoramento-table-wrapper">
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines monitoramento-table"
            [paginator]="true" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros"
            [showCurrentPageReport]="true"
            [globalFilterFields]="['id','estacao','situacao', 'inicio', 'fim']">

            <ng-template pTemplate="caption">
                <div class="table-caption">
                    <div class="caption-title">
                        <h5 class="p-m-0">Resumo de monitoramento</h5>
                        <span class="caption-subtitle" *ngIf="data.length > 0">{{ data.length }} registro(s)</span>
                    </div>
                    <span class="p-input-icon-left search-input">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                            placeholder="Buscar código, estação, situação..." />
                    </span>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 90px;">Código</th>
                    <th>Estação</th>
                    <th style="width: 150px;">Situação</th>
                    <th style="width: 160px;">Início</th>
                    <th style="width: 160px;">Fim</th>
                    <th style="width: 80px; text-align: center;">Envios</th>
                    <th style="width: 80px; text-align: center;">Detalhes</th>
                    <th style="width: 70px; text-align: center;">Ações</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-dt>
                <tr>
                    <td><span class="p-column-title negrito">Código: </span><span class="codigo-badge">#{{ dt.id }}</span></td>
                    <td><span class="p-column-title negrito">Estação: </span><span class="estacao-nome">{{ dt.estacao }}</span></td>
                    <td>
                        <span class="p-column-title negrito">Situação: </span>
                        <span class="situacao-badge" [class.situacao-aberta]="dt.situacao === 'Em Monitoramento'"
                            [class.situacao-fechada]="dt.situacao === 'Fechado'">{{ dt.situacao }}</span>
                    </td>
                    <td><span class="p-column-title negrito">Início: </span>{{ dt.inicio }}</td>
                    <td><span class="p-column-title negrito">Fim: </span>{{ dt.fim || '—' }}</td>
                    <td style="text-align: center;">
                        <span class="p-column-title negrito">Envios: </span>
                        <button pButton pRipple icon="pi pi-envelope"
                            [disabled]="!permissaoService.can('monitoramento_envios')"
                            class="p-button-rounded p-button-info p-button-text" pTooltip="Logs de e-mail"
                            (click)="envios(dt)"></button>
                    </td>
                    <td style="text-align: center;">
                        <span class="p-column-title negrito">Detalhes: </span>
                        <button pButton pRipple icon="pi pi-eye"
                            [disabled]="!permissaoService.can('monitoramento_observacoes')"
                            class="p-button-rounded p-button-help p-button-text" pTooltip="Ver detalhes"
                            (click)="observacao(dt)"></button>
                    </td>
                    <td style="text-align: center;">
                        <span class="p-column-title negrito">Ações: </span>
                        <button pButton pRipple icon="pi pi-trash"
                            [disabled]="!permissaoService.can('monitoramento_excluir')"
                            class="p-button-rounded p-button-danger p-button-text" pTooltip="Excluir monitoramento"
                            (click)="confirmarExclusao(dt)"></button>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">
                        <div class="empty-state">
                            <i class="pi pi-exclamation-triangle empty-icon-warn" *ngIf="!load"></i>
                            <i class="pi pi-spin pi-spinner empty-icon-loading" *ngIf="load"></i>
                            <strong *ngIf="!load">Selecione o período e clique em Filtrar</strong>
                            <strong *ngIf="load">Carregando monitoramentos...</strong>
                            <p *ngIf="!load">Use os filtros acima para consultar os monitoramentos das estações.</p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-dialog [header]="estacaoModal ? 'Logs de E-mail - ' + estacaoModal : 'Logs de E-mail'" [(visible)]="modal" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '75vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <p-table #dtModal [value]="dataModal" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id" [loading]="loadModal"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros"
            [showCurrentPageReport]="true" [globalFilterFields]="['mensagem','data_hora']">

            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="p-m-0">Logs de E-mail Enviados</h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dtModal.filterGlobal($event.target.value, 'contains')"
                            placeholder="Pesquisar..." />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>Data/Hora</th>
                    <th>Status</th>
                    <th>Grupo de E-mail</th>
                    <th>Destinatários</th>
                    <th>Mensagem</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-log>
                <tr>
                    <td>
                        <span class="p-column-title negrito">Data/Hora: </span>
                        {{formatarDataHora(log.data_hora)}}
                    </td>
                    <td>
                        <span class="p-column-title negrito">Status: </span>
                        <span [ngClass]="log.sucesso ? 'p-badge p-badge-success' : 'p-badge p-badge-danger'">
                            {{log.sucesso ? 'Sucesso' : 'Erro'}}
                        </span>
                    </td>
                    <td>
                        <span class="p-column-title negrito">Grupo de E-mail: </span>
                        {{log.grupo_email?.descricao || 'N/A'}}
                    </td>
                    <td>
                        <span class="p-column-title negrito">Destinatários: </span>
                        <div *ngIf="log.emailsParsed && log.emailsParsed.to && log.emailsParsed.to.length > 0">
                            <strong>Para:</strong> {{log.emailsParsed.to.join(', ')}}
                        </div>
                        <div *ngIf="log.emailsParsed && log.emailsParsed.cc && log.emailsParsed.cc.length > 0">
                            <strong>CC:</strong> {{log.emailsParsed.cc.join(', ')}}
                        </div>
                        <span *ngIf="!log.emailsParsed || !log.emailsParsed.to || log.emailsParsed.to.length === 0">N/A</span>
                    </td>
                    <td>
                        <span class="p-column-title negrito">Mensagem: </span>
                        {{log.mensagem}}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5" style="text-align: center;">
                        <span *ngIf="!loadModal">Nenhum log de e-mail encontrado para esta estação.</span>
                        <span *ngIf="loadModal">Carregando...</span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-dialog>

<app-eventos-monitoramentos-dialog
    #eventosMonitoramentosDialog
    (saved)="filtrar()">
</app-eventos-monitoramentos-dialog>

<p-dialog [(visible)]="modalNovoGrupo" header="Novo Grupo de estações"
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}">
    <app-grupo-estacao-formulario (onSave)="aoSalvarNovoGrupo()"></app-grupo-estacao-formulario>
</p-dialog>

<p-toast></p-toast>
